import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {MatListModule} from '@angular/material/list';

import { Site } from '../../../../models/Site';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { SiteService } from '../../../../services/site.service';
import { RegionsService } from '../../../../services/regions.service';
import { Region } from '../../../../models/Region';
import { takeUntil, debounceTime, distinctUntilChanged, first } from 'rxjs/operators';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.css']
})
export class AddSiteComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  private $sites: BehaviorSubject<Site[]> = new BehaviorSubject(null);
  public sites: Observable<Site[]> = this.$sites.asObservable();

  private subSiteNameChange: Subject<string> = new Subject<string>();
 
  selectedSites: number[] = [];
  region$: BehaviorSubject<Region> = new BehaviorSubject<Region>(null);
  parent: Region = null;
  region: Region = null;
  regionName: string = null;
  siteNameFilter: string = null;
  message: string = null;

  constructor(public dialogRef: MatDialogRef<AddSiteComponent>,
    private siteService: SiteService,
    private regionService: RegionsService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      // this.region$
      //   .pipe(takeUntil(this.destroy$))
      //   .subscribe(region => {
      //     this.region = region;
      // });
      // this.region$.next(data.region as Region);
      console.log(data);
      if (data.parentRegion) {
        this.parent = (data.parentRegion as Region);
        this.regionName = this.parent.region_label;
      }      
      if (data.region) {
        this.region = (data.region as Region);
        this.regionName += ` > ${this.region.region_label}`;
      }
    }

  ngOnInit() {
    this.subSiteNameChange
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeUntil(this.destroy$))
      .subscribe(value => {
         // Debounce this
        this.siteService.getSitesByName(value).subscribe(sites => {
          this.$sites.next(sites);
        })
    });
  }
  
  ngOnDestroy(): void {
    // End all other subscriptions and unsubscribe from ourself
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onNgModelChange(event) {
    console.log("on ng model change ", event);
  }

  // Update site name filter as the user enters a value
  onSiteSearch(value: string) {
    this.siteNameFilter = value;
    this.subSiteNameChange.next(value);   
    if (this.siteNameFilter == null || this.siteNameFilter.length==0) {
      this.selectedSites = [];
    }
  }

  assignSiteToRegion(event) {
    this.regionService.addSitesToRegion(this.region, this.selectedSites)
      .pipe(first())
      .subscribe(next => {
        this.message = "Successfully assigned sites to region."
        console.log(next);
      },
      error => {
        this.message = "Could not assign sites to region."
        console.log(error);
      });      
  }

  onCancel(event): void {
    this.dialogRef.close();
  }
}
